// Space Theme — color palette & shared style tokens
export const C = {
  bg:           '#010614',
  surface:      'rgba(6, 12, 28, 0.92)',
  surfaceHigh:  'rgba(10, 18, 42, 0.96)',
  sidebar:      'rgba(3, 8, 22, 0.97)',
  input:        'rgba(2, 5, 16, 0.85)',
  border:       'rgba(99, 102, 241, 0.16)',
  borderHover:  'rgba(99, 102, 241, 0.45)',
  borderSubtle: 'rgba(99, 102, 241, 0.08)',
  primary:      '#818cf8',
  primaryDark:  '#6366f1',
  primaryGrad:  'linear-gradient(135deg, #6366f1 0%, #818cf8 100%)',
  accent:       '#38bdf8',
  accentGrad:   'linear-gradient(135deg, #0ea5e9 0%, #38bdf8 100%)',
  cosmicGrad:   'linear-gradient(135deg, #6366f1 0%, #a855f7 50%, #38bdf8 100%)',
  success:      '#34d399',
  successBg:    'rgba(52, 211, 153, 0.1)',
  warning:      '#fbbf24',
  warningBg:    'rgba(251, 191, 36, 0.1)',
  danger:       '#f87171',
  dangerBg:     'rgba(248, 113, 113, 0.1)',
  pink:         '#f472b6',
  orange:       '#fb923c',
  text:         '#e2e8f0',
  textMuted:    '#64748b',
  textFaint:    '#1e2d47',
};

// Shared reusable style objects
export const shared = {
  page: {
    padding: '28px 32px',
    flex: 1,
    overflowY: 'auto',
    background: 'transparent',
    color: C.text,
  },
  card: {
    background: C.surface,
    border: `1px solid ${C.border}`,
    borderRadius: 12,
    padding: 24,
    backdropFilter: 'blur(12px)',
    WebkitBackdropFilter: 'blur(12px)',
  },
  cardHigh: {
    background: C.surfaceHigh,
    border: `1px solid ${C.border}`,
    borderRadius: 12,
    padding: 24,
    backdropFilter: 'blur(16px)',
    WebkitBackdropFilter: 'blur(16px)',
  },
  input: {
    width: '100%',
    padding: '11px 14px',
    background: C.input,
    border: `1px solid ${C.border}`,
    borderRadius: 8,
    color: C.text,
    fontSize: 14,
    outline: 'none',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
  },
  label: {
    display: 'block',
    marginBottom: 8,
    fontSize: 12,
    fontWeight: 600,
    color: C.textMuted,
    letterSpacing: 0.3,
    textTransform: 'uppercase',
  },
  btnPrimary: {
    padding: '11px 22px',
    background: C.primaryGrad,
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    fontWeight: 600,
    cursor: 'pointer',
    fontSize: 14,
    fontFamily: 'inherit',
  },
  btnSecondary: {
    padding: '8px 16px',
    background: 'rgba(99, 102, 241, 0.12)',
    color: C.primary,
    border: `1px solid ${C.border}`,
    borderRadius: 8,
    fontWeight: 600,
    cursor: 'pointer',
    fontSize: 13,
    fontFamily: 'inherit',
  },
  btnDanger: {
    padding: '11px 22px',
    background: 'transparent',
    border: `1px solid ${C.danger}`,
    color: C.danger,
    borderRadius: 8,
    fontWeight: 600,
    cursor: 'pointer',
    fontSize: 14,
    fontFamily: 'inherit',
  },
  sectionTitle: {
    margin: '0 0 18px',
    fontSize: 16,
    fontWeight: 600,
    color: C.text,
    letterSpacing: -0.2,
  },
  title: {
    fontSize: 22,
    fontWeight: 700,
    color: C.text,
    margin: 0,
    letterSpacing: -0.3,
  },
};

// Framer Motion page entry variant
export const pageVariants = {
  hidden: { opacity: 0, y: 14 },
  show:   { opacity: 1, y: 0, transition: { duration: 0.38, ease: [0.25, 0.46, 0.45, 0.94] } },
};

// Framer Motion stagger container
export const staggerContainer = {
  hidden: {},
  show:   { transition: { staggerChildren: 0.07, delayChildren: 0.1 } },
};

// Framer Motion stagger child
export const staggerItem = {
  hidden: { opacity: 0, y: 18 },
  show:   { opacity: 1, y: 0, transition: { duration: 0.35, ease: [0.25, 0.46, 0.45, 0.94] } },
};
